var React = require('react');

function CloseIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26.1331 0.769781L30.0493 4.68606L4.5935 30.1419L0.677219 26.2256L26.1331 0.769781Z","fill":"white","key":0}),React.createElement("path",{"d":"M30.0493 26.2256L26.1331 30.1419L0.677218 4.68606L4.5935 0.76978L30.0493 26.2256Z","fill":"white","key":1})]);
}

CloseIconInline.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none"};

module.exports = CloseIconInline;

CloseIconInline.default = CloseIconInline;
